<template>
  <div>
    <status-dialog
      v-model="isStatusDialogOpened"
      :status="selectedStatus"
      :maker="maker"
      @save="stateSave"
      @close="resetSelectedStatus"/>
    <delete-status-dialog
      v-model="isDeleteStatusDialogOpened"
      :status="selectedStatus"
      @delete="stateDelete"
      @close="resetSelectedStatus"/>
    <v-row no-gutters align="center" class="content-header">
      <span class="font-weight-bold">Statuts</span>
      <v-spacer></v-spacer>
      <v-btn :disabled="!$canWrite" dark color="primary" elevation="0" @click="$canWrite && (isStatusDialogOpened = true)" v-if="admin">
        <v-icon left>add</v-icon>
        Nouveau statut
      </v-btn>
    </v-row>
    <slot name="beforeList" />
    <n-card v-if="isFetching">
      <v-row no-gutters justify="center" align="center" class="my-8">
        <v-progress-linear
          color="primary"
          indeterminate
          rounded
          height="6"
          style="max-width: 200px;"
        ></v-progress-linear>
      </v-row>
    </n-card>
    <n-card v-else-if="!statuses.length">
      <v-row no-gutters justify="center" align="center" class="pa-4 text--secondary" style="min-height: 100px;">
        Aucun statut
      </v-row>
    </n-card>
    <div class="page-main-content" v-else>
      <v-simple-table class="pt-5">
        <thead>
          <tr>
            <th class="text-left">Nom</th>
            <th class="text-left">Couleur</th>
            <th class="text-left">Intervention cloturée ?</th>
            <th/>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(status, i) in statuses" :key="status.id">
            <td>{{ status.name }}</td>
            <td>
              <v-sheet
                width="125"
                height="15"
                :color="status.color"
                class="sheet-item"
              ></v-sheet>
            </td>
            <td>{{ status.isFinished ? `Oui` : `Non` }}</td>
            <td class="text-right admin-list-actions">
              <v-btn :disabled="!$canWrite" icon small @click="$canWrite && (saveStatus(status))" v-if="admin"><v-icon>edit</v-icon></v-btn>
              <v-btn
                icon
                small
                v-if="(i !== 0 && i !== statuses.length - 1 && admin)"
              >
                <v-icon :disabled="!$canWrite" color="red" @click="$canWrite && (deleteStatus(status))">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import StatusDialog from '@/components/Status/StatusDialog.vue';
import DeleteStatusDialog from '@/components/Status/DeleteStatusDialog.vue';

export default {
  name: `SettingsStatusesList`,
  props: {
    maker: Object,
    admin: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => ({
    isFetching: true,
    isStatusDialogOpened: false,
    isDeleteStatusDialogOpened: false,
    selectedStatus: {},
  }),
  computed: {
    ...mapState(`model/status`, [
      `statuses`,
    ]),
  },
  methods: {
    ...mapMutations(`model/status`, [
      `SET_STATUSES`,
    ]),
    ...mapActions(`model/status`, {
      storeFetchStatuses: `fetchListForMaker`,
    }),
    saveStatus(status) {
      this.selectedStatus = status;
      this.isStatusDialogOpened = true;
    },
    deleteStatus(status) {
      this.selectedStatus = status;
      this.isDeleteStatusDialogOpened = true;
    },
    async fetchStatuses() {
      this.isFetching = true;
      this.SET_STATUSES([]);
      const statuses = await this.storeFetchStatuses(this.maker.id);
      this.SET_STATUSES(statuses);
      this.isFetching = false;
    },
    async stateSave() {
      await this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: this.selectedStatus && this.selectedStatus.id ? `Statut modifié avec succès` : `Statut créé avec succès`,
      });
      this.selectedStatus = {};
    },
    async stateDelete() {
      await this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Statut supprimé avec succès`,
      });
      this.selectedStatus = {};
    },
    resetSelectedStatus() {
      this.selectedStatus = {};
    },
  },
  mounted() {
    this.fetchStatuses();
  },
  components: {
    StatusDialog,
    DeleteStatusDialog,
  },
};
</script>

<style lang="scss">
  .sheet-item {
    border: 2px solid rgba(119, 119, 119, 0.527) !important;
    border-radius: 4px;
  }
</style>
